namespace $.$$ {
	$mol_style_define( $shm_showcase_table, {
		Cell_text: {
			'[column]': {
				title: { whiteSpace: 'normal', minWidth: '12rem', maxWidth: '16rem' },
				description: { whiteSpace: 'normal', minWidth: '20rem', maxWidth: '28rem' },
			},
		},
	} )
}
